import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAreas, getRealEstates, getWorkTypes } from './api';

export const path = '/dashboard/kpi/executor/list';

const PageKPIExecutorListDashboard: React.FC = (props) => {
  const KPIExecutorListDashboard = Loadable.Map({
    loader: {
      page: () => import('./page'),
      areas: getAreas,
      realEstates: getRealEstates,
      workTypes: getWorkTypes,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <KPIExecutorListDashboard {...props} />;
};

export default PageKPIExecutorListDashboard;
